import { render } from "./RetailerCard.vue?vue&type=template&id=29a363bd&scoped=true"
import script from "./RetailerCard.vue?vue&type=script&lang=js"
export * from "./RetailerCard.vue?vue&type=script&lang=js"

import "./RetailerCard.vue?vue&type=style&index=0&id=29a363bd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a363bd"]])

export default __exports__